import { render, staticRenderFns } from "./ProductsPage.vue?vue&type=template&id=8967a8fe&scoped=true&"
import script from "./ProductsPage.vue?vue&type=script&lang=js&"
export * from "./ProductsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8967a8fe",
  null
  
)

export default component.exports